<div class="main-container" *ngIf="schoolService.selectedSchool">
    <div class="left-container">
        <p-tabMenu [model]="navigationItems" [activeItem]="activeItem"></p-tabMenu>
        <p-toast></p-toast>
        <app-school-edit #editComponent *ngIf="activeItemId == 1"></app-school-edit>
        <app-school-file-upload #fileUpload *ngIf="activeItemId == 3"></app-school-file-upload>
        <app-school-course-edit #editCourse *ngIf="activeItemId == 5"></app-school-course-edit>
        <app-school-quotation-templates *ngIf="activeItemId == 4"></app-school-quotation-templates>
        <app-school-bookings *ngIf="activeItemId == 6"></app-school-bookings>
    </div>
    <div class="right-container">
        <p>
            Actions
        </p>
        <div class="submit-delete-box">
            <p-button label="Submit" (onClick)="submit()"
                [disabled]="schoolService.updatingSchool || this.schoolService.selectedSchool.isDeleted"></p-button>
            <p-button icon="pi pi-trash" label="Delete this school" (onClick)="deleteSchool()" *ngIf="!schoolService.selectedSchool.isDeleted"
                styleClass="p-button-danger"></p-button>
            <p-button label="Restore this school" (onClick)="restoreSchool()" *ngIf="schoolService.selectedSchool.isDeleted"></p-button>
        </div>
    </div>
</div>
<p-confirmDialog icon="pi pi-exclamation-triangle">
</p-confirmDialog>